import script from "./List.vue?vue&type=script&setup=true&lang=ts"
export * from "./List.vue?vue&type=script&setup=true&lang=ts"

import "./List.vue?vue&type=style&index=0&id=497c2006&lang=css"

const __exports__ = script;

export default __exports__